module.exports = __webpack_public_path__ + "static/media/Vantr-v.d44b8445.png";